import { SecondaryColor } from 'glints-aries';
import styled from 'styled-components';

import { ellipsis } from 'src/components/Ellipsis.sc';

export const Root = styled.div``;

export const TextWrapper = styled.div<{ isReadMore: boolean }>`
  margin-bottom: 12px;
  white-space: pre-line;
  ${({ isReadMore }) => (isReadMore ? `word-break: break-word;` : ellipsis(3))}
`;

export const ElementWrapper = styled.div<{ isReadMore: boolean }>`
  white-space: pre-line;
  ${({ isReadMore }) =>
    isReadMore
      ? 'height: auto; opacity: 1; margin-bottom: 12px;'
      : 'height: 0; opacity: 0; overflow: hidden;'}
  transition: all 0.2s ease-in-out;
`;

export const ButtonContainer = styled.div`
  svg {
    margin-right: 8px;
  }
  button {
    font-size: 14px;
  }
`;

export const Toggle = styled.div`
  font-size: 14px;
  cursor: pointer;
  color: ${SecondaryColor.actionblue};
  &:hover {
    color: #004b68;
  }
`;
